import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-start text-lg" }, "Editar Usuário", -1)
const _hoisted_2 = {
  key: 1,
  class: "text-center py-10"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-gray-600" }, "Carregando dados do usuário...", -1)

import { reactive, ref, watch } from 'vue'
import { VForm } from 'vuetify/components'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import Network from '@/Network'
import { useToast } from 'vue-toastification'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import { UpdateUserPayload } from '@/Network/Types/Requests/CompanyRequests'
import { CompanyUserResponse } from '@/Network/Types/Responses/CompanyResponses'
import { storeToRefs } from 'pinia'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    modalActive: { type: Boolean },
    userData: {}
  },
  emits: ['close', 'user-updated'],
  setup(__props: any, { emit: emits }) {

const props = __props;




const formRef = ref<InstanceType<typeof VForm> | null>(null)
const loadingSubmit = ref(false)
const toast = useToast()
const loadingInitialData = ref(false)

const { listCompanies } = storeToRefs(useCompanyStore())

const getInitialFormState = () => ({
  name: '',
  email: '',
  phone1: '',
  registration: null as string | null,
  companies: [] as string[]
})
const form = reactive(getInitialFormState())

const rules = {
  required: (v: any) => !!v || 'Campo obrigatório',
  requiredList: (v: any[]) => (v && v.length > 0) || 'Selecione pelo menos uma empresa',
  name: (v: string) => (v && v.length >= 3) || 'Nome deve ter no mínimo 3 caracteres',
  phone: (v: string) => (v && v.length === 15) || 'Telefone inválido'
}

watch(
  () => props.userData,
  (newUserData) => {
    if (newUserData && props.modalActive) {
      loadingInitialData.value = true
      form.name = newUserData.user.name
      form.email = newUserData.user.email
      form.phone1 = newUserData.user.mainPhone?.phoneNumber || ''
      form.registration = newUserData.user.registration ?? null
      form.companies = newUserData.companies.map((c: any) => String(c.id))

      loadingInitialData.value = false
    } else if (!props.modalActive) {
      resetForm()
    }
  },
  { immediate: true, deep: true }
)

const resetForm = () => {
  Object.assign(form, getInitialFormState())
  formRef.value?.resetValidation()
}

const close = () => {
  resetForm()
  emits('close')
}

const updateUser = async () => {
  if (!formRef.value || !props.userData) return

  const { valid } = await formRef.value.validate()
  if (!valid) {
    toast.warning('Por favor, preencha corretamente os campos obrigatórios.')
    return
  }

  try {
    loadingSubmit.value = true

    const payload: UpdateUserPayload = {
      name: form.name,
      phone: form.phone1.replace(/\D/g, ''),
      registration: form.registration ?? undefined,
      companies: form.companies.map((id) => Number(id))
    }

    await Network.company.updateUser(props.userData.user.id, payload)
    toast.success('Usuário atualizado com sucesso!')
    emits('user-updated')
    close()
  } catch (e: any) {
    const message = e.response?.data?.message || 'Erro ao atualizar usuário. Tente novamente!'
    toast.error(message)
  } finally {
    loadingSubmit.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: close,
    modalActive: _ctx.modalActive,
    "has-header-border": true,
    "has-footer-border": true
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_v_row, {
        dense: "",
        justify: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "auto"
          }, {
            default: _withCtx(() => [
              _createVNode(OutlineButton, {
                onClick: close,
                text: "Cancelar",
                width: "140px"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "auto"
          }, {
            default: _withCtx(() => [
              _createVNode(FilledButton, {
                loading: loadingSubmit.value,
                onClick: updateUser,
                text: "Salvar Alterações",
                width: "180px",
                type: "submit"
              }, null, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (!loadingInitialData.value)
        ? (_openBlock(), _createBlock(_unref(VForm), {
            key: 0,
            ref_key: "formRef",
            ref: formRef,
            onSubmit: _withModifiers(updateUser, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                dense: "",
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(GenericInput, {
                        modelValue: form.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
                        label: "Nome*",
                        rules: [rules.required, rules.name],
                        variant: "outlined"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(GenericInput, {
                        modelValue: form.email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.email) = $event)),
                        label: "Email",
                        variant: "outlined",
                        disabled: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(GenericInput, {
                        modelValue: form.phone1,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.phone1) = $event)),
                        label: "Telefone*",
                        rules: [rules.required, rules.phone],
                        variant: "outlined"
                      }, null, 8, ["modelValue", "rules"]), [
                        [_directive_maska, '(##) #####-####']
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(GenericInput, {
                        modelValue: form.registration,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.registration) = $event)),
                        label: "Matrícula",
                        rules: [],
                        variant: "outlined",
                        placeholder: "Não definida"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_autocomplete, {
                        modelValue: form.companies,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.companies) = $event)),
                        items: _unref(listCompanies),
                        "item-title": "title",
                        "item-value": "value",
                        label: "Empresas*",
                        multiple: "",
                        chips: "",
                        "closable-chips": "",
                        variant: "outlined",
                        color: "primary20",
                        rules: [rules.requiredList]
                      }, null, 8, ["modelValue", "items", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary"
            }),
            _hoisted_3
          ]))
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})